import { c as _c } from "react/compiler-runtime";
import { Box, Flex, HStack, Image, Text, VStack, Separator } from '@chakra-ui/react';
type SocialProofFeatureCardProps = {
  title: string;
  bgImage?: string;
  customerLogo?: string;
  customerLogoWidth?: string;
  aspectRatio?: string;
};
export const SocialProofFeatureCard = props => {
  const $ = _c(15);
  const t0 = props.aspectRatio || "16/9";
  const t1 = `url(${props.bgImage})`;
  let t2;
  if ($[0] !== props.customerLogo || $[1] !== props.customerLogoWidth) {
    t2 = props.customerLogo && <Box width={props.customerLogoWidth || "64px"}><Image alt="customer logo" filter={{
        _light: "invert(1)",
        _dark: "invert(0)"
      }} maxWidth={props.customerLogoWidth || "64px"} objectFit="contain" src={props.customerLogo} /></Box>;
    $[0] = props.customerLogo;
    $[1] = props.customerLogoWidth;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = props.customerLogo ? "block" : "none";
  let t4;
  if ($[3] !== t3) {
    t4 = <Separator borderColor="red.fg/50" display={t3} height="6" opacity={0.5} orientation="vertical" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props.title) {
    t5 = props.title && <VStack align="flex-start" gap={0}><Text color="red.fg/75" fontSize="sm" fontWeight={600}>{props.title}</Text></VStack>;
    $[5] = props.title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <HStack align="center" backdropFilter="blur(10px)" bgColor="colorPalette.bg/75" borderBottomRadius="2xl" gap={4} justify="center" padding={4} width="full">{t2}{t4}{t5}</HStack>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t6) {
    t7 = <Flex align="center" aspectRatio={t0} bgColor="Slate" bgImage={t1} bgPos="center" bgRepeat="no-repeat" bgSize="cover" borderRadius="2xl" boxShadow="lg" direction="column" justify="end" padding={0} width="full">{t6}</Flex>;
    $[11] = t0;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};